import { observer } from 'mobx-react';
import { useEffect } from 'react';

import { Store } from './stores';
import { SearchForm } from './components';
import { CodeForm } from './components/CodeForm';

const Page = () => {
  const store = Store.use();

  useEffect(() => {
    store.resetCache();
  }, [store]);

  return !store.isCodeSend ? <SearchForm /> : <CodeForm />;
};

export const PageIndex = observer(Page);
